import '../styles/Skills.css';
import { TargetSkills } from './ui/TargetSkills.jsx';
import { TargetExtraSkills } from './ui/TargetExtraSkills.jsx';

import iconCss from '../assets/css3.svg';
import iconJs from '../assets/javascript.svg';
import iconGit from '../assets/git.svg';
import iconReact from '../assets/react.svg';
import iconMySql from '../assets/mysql.svg';
import iconFigma from '../assets/figma.svg';
import iconNet from '../assets/net.png';
import iconJava from '../assets/java.svg';
import iconSql from '../assets/sql.png';
import iconPhp from '../assets/iconPhp.png';
import iconC from '../assets/iconC.png';
import iconFirebase from '../assets/iconFirebase.png';
import iconVue2 from '../assets/iconVue2.png';
import iconJira from '../assets/iconJira.png';
import iconPython from '../assets/python.png';
import iconQgis from '../assets/qgis.png';
import iconNode from '../assets/iconNode.png';
import iconMapbox from '../assets/iconMapbox.png';
import iconPostman from '../assets/postman.png';
export function Skills(){
  return(
    <section id="skills" className="skills">
      <h3 className="title">Tecnologías y herramientas</h3>
      <div className="skills-content">

        <div className="skills-target-content">
          <TargetSkills img={iconCss} name="CSS" />
          <TargetSkills img={iconJs} name="JavaScript" />
          <TargetSkills img={iconNet} name=". Net Core" />
          <TargetSkills img={iconReact} name="React.js" />
          <TargetSkills img={iconVue2} name="Vue.js" />
          <TargetSkills img={iconJava} name="Java" />
          <TargetSkills img={iconMySql} name="MySQL" />
          <TargetSkills img={iconPython} name="Python" />
        </div>

        <div className="extra-skills-groups">

          <div className="extra-skills-group">
            <h4 className="skills-group-title">Más lenguajes y frameworks</h4>
            <div className="extra-skills-content">
              <TargetExtraSkills img={iconPhp} name="PHP" />
              <TargetExtraSkills img={iconC} name="C Sharp" />
              <TargetExtraSkills name="TypeScript" />
              <TargetExtraSkills name="Bash" />
              <TargetExtraSkills name="Laravel" />
              <TargetExtraSkills name="Angular" />
              <TargetExtraSkills name="React Native" />
              <TargetExtraSkills img={iconNode} name="Node.js" />
              <TargetExtraSkills name="API REST" />
            </div>
          </div>

          <div className="extra-skills-group">
            <h4 className="skills-group-title">Bases de datos y servidores</h4>
            <div className="extra-skills-content">
              <TargetExtraSkills img={iconSql} name="SQL Server" />
              <TargetExtraSkills img={iconFirebase} name="Firebase" />
              <TargetExtraSkills name="Linux" />
              <TargetExtraSkills name="Windows Server" />
            </div>
          </div>

          <div className="extra-skills-group">
            <h4 className="skills-group-title">DevOps y herramientas</h4>
            <div className="extra-skills-content">
              <TargetExtraSkills img={iconGit} name="Git" />
              <TargetExtraSkills name="GitHub" />
              <TargetExtraSkills name="GitLab CI" />
              <TargetExtraSkills name="Jenkins" />
              <TargetExtraSkills img={iconJira} name="Jira" />
              <TargetExtraSkills img={iconFigma} name="Figma" />
              <TargetExtraSkills img={iconPostman} name="Postman" />
            </div>
          </div>

          <div className="extra-skills-group">
            <h4 className="skills-group-title">Geoespacial</h4>
            <div className="extra-skills-content">
              <TargetExtraSkills img={iconQgis} name="QGIS / PyQGIS" />
              <TargetExtraSkills img={iconMapbox} name="Mapbox" />
            </div>
          </div>

          <div className="extra-skills-group">
            <h4 className="skills-group-title">Gestión y seguridad de TI</h4>
            <div className="extra-skills-content">
              <TargetExtraSkills name="ITIL 4" />
              <TargetExtraSkills name="COBIT" />
              <TargetExtraSkills name="Scrum" />
              <TargetExtraSkills name="ISO 27001" />
              <TargetExtraSkills name="Autenticación centralizada" />
            </div>
          </div>

        </div>

      </div>
    </section>
  );
}
